export default "__VITE_ASSET__n_ysdFQu__"